import React, {useEffect, useState} from 'react';
import {DataGrid} from '@mui/x-data-grid';
import {getRFIDMappingList} from '../../services/asset.service'
import * as CryptoJS from "crypto-js";

function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return year + '-' + month + '-' + day;
        //return `${dte.getFullYear()}-${dte.getMonth()+1}-${dte.getDate()}`;
    } else {
        return null;
    }
}


function ListRFIDMapping() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const columns = [
        {"field": "tag", "editable": false, "hide": false, "headerName": "TAG", "width": 250},
        {"field": "epc_no", "editable": false, "hide": false, "headerName": "EPC No", "width": 250},
        {
            "field": "updated_at", "editable": false, "hide": false, "headerName": "Date of Linking/De-linking", "width": 230,
            renderCell: (params) => (
                <p>{getFormatedDate(params.row.updated_at)}</p>
            )
        }
    ];

    useEffect(() => {
        // encrypted data
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            // 'param_data':obj,
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = {'token': EncryptData};

        // Show loader when the request starts
        setLoading(true);

        // Fetch division list
        getRFIDMappingList(oData)
            .then((res) => {
                if (res?.data?.data?.length) {
                    setItems(res.data.data);
                }
            })
            .catch((error) => {
                console.error('Error fetching rfid list:', error);
            })
            .finally(() => {
                // Hide loader when the request completes (either success or failure)
                setLoading(false);
            });
    }, []);  // Empty dependency array means this effect runs once on mount


    // readDivision();
    return (
        <div className='container'>
            <div className='row mb-4'>
                <div className='col-md-6'><h5>View RFID TAG Mapping List</h5></div>

            </div>

            {loading ? (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <DataGrid
                    rows={items}
                    getRowId={(row) => row.tag}
                    columns={columns}
                    pageSize={50}
                    autoHeight
                    rowsPerPageOptions={[50]}
                />
            )}

        </div>
    )
}

export default ListRFIDMapping
